import { render, staticRenderFns } from "./logsList.vue?vue&type=template&id=4ae12ed2&"
import script from "./logsList.vue?vue&type=script&lang=js&"
export * from "./logsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports